import  request  from '../../Interceptor/request.js'

//缴费记录查询
export function record() {
    return request({
        url: '/order/listOwners',
        method: 'get'
    })
}

//期数具体数据
export function selection(data){
    return request({
        url:'/order/listTime',
        method: 'get',
        params:data
    })
}
